import { useLang } from '../i18n'
import { RELEASES } from '../lib/releases'
import { navigate, homePath } from '../lib/router'

function formatDate(iso: string, lang: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString(lang === 'fr' ? 'fr-FR' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}

/**
 * Release notes — functional changes per version (curated in lib/releases.ts), newest first.
 * A top-level page (its own URL /releases), shown like the home landing.
 */
export function ReleaseNotes() {
  const { t, lang } = useLang()
  return (
    <main className="homepage" aria-label={t('releases_title')}>
      <div className="home-hero">
        <div className="home-hero-in">
          <button className="rel-back" onClick={() => navigate(homePath)}>← {t('all_bids')}</button>
          <span className="home-eyebrow">{t('whats_new')}</span>
          <h1>{t('releases_title')}</h1>
          <p>{t('releases_sub')}</p>
        </div>
      </div>

      <div className="rel-list">
        {RELEASES.map((r) => (
          <section key={r.version} className="rel" aria-label={`v${r.version}`}>
            <div className="rel-aside">
              <span className="rel-ver">v{r.version}</span>
              <time className="rel-date" dateTime={r.date}>{formatDate(r.date, lang)}</time>
            </div>
            <div className="rel-body">
              <h2>{r.title[lang]}</h2>
              <ul>
                {r.highlights.map((h, i) => (
                  <li key={i}>{h[lang]}</li>
                ))}
              </ul>
            </div>
          </section>
        ))}
      </div>
    </main>
  )
}
